import React from "react";

const OccupationalRhinitisToolTip = () => {
  return (
    <div className="bg-gray-10 p-2 flex flex-col max-w-[460px]">
      <p className="text-teal-300 text-left text-body-sm p-2 font-normal">
        Intermittent or persistent symptoms are similar to those of Allergic Rhinitis and generally
        develop within the first couple of years of working in the environment.
        Symptoms may develop immediately or several hours after exposure to the
        inciting stimuli. Often there are associated ocular and pulmonary
        symptoms. 
        <br/>
        (Ref Medsask Guidelines)
      </p>
    </div>
  );
};

export default OccupationalRhinitisToolTip;
